import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { EducationalContent } from '@com-delta-idp/mnx-skymiles-educational-content-ui';
import { StateFacade } from '../../data-access/facades/state.facade';
@Component({
  selector: 'idp-educational-content',
  templateUrl: './educational-content.component.html',
  styleUrls: ['./educational-content.component.scss']
})
export class EducationalContentComponent implements OnInit {
  emptyContent: EducationalContent = {} as EducationalContent;
  @Output() viewBenefitsAction = new EventEmitter<string>();

  constructor(public educationalPage: StateFacade) {}

  ngOnInit() {
    this.educationalPage.init();
  }

  redirect(link: string) {
    window.open(link, '_blank');
  }
}
